import { useOutletContext } from 'react-router-dom';

import { ButtonGroupProvider } from 'components/buttonGroup/ButtonGroupContext';
import { OutletContextDeviceType } from 'components/layout/model';
import withErrorBoundary from 'components/provider/withErrorBoundary';
import { TabListProvider } from 'components/tabList/TabListContext';
import Flex from 'components/util/Flex';

import CreatorInformationContainer from './components/creatorInformation/CreatorInformationContainer';
import MonthlyRevenueRankingContainer from './components/monthlyRevenueRanking/MonthlyRevenueRankingContainer';
import RevenueChartContainer from './components/revenueChart/RevenueChartContainer';
import RevenueInformationContainer from './components/revenueInformation/RevenueInformationContainer';
import { rankingAssetOwner, rankingAssetType } from './constants/rankingType';
import { chartAssetTypes, chartPeriodTypes } from './constants/revenueChartType';

function DashBoardPage() {
  const { device } = useOutletContext<OutletContextDeviceType>();

  return (
    <Flex rowGap={8} direction="column">
      {/* User Information Section */}
      <Flex
        columnGap={device.isDesktop ? 8 : 0}
        rowGap={device.isDesktop ? 0 : 8}
        isExpanded
        direction={device.isDesktop ? 'row' : 'column'}
      >
        <RevenueInformationContainer />
        <CreatorInformationContainer />
      </Flex>
      {/* Revenue Chart Section */}
      <Flex isExpanded>
        <ButtonGroupProvider
          buttonGroup={chartPeriodTypes}
          storage={{
            name: 'revenueChartButtonGroup',
            type: 'session',
          }}
        >
          <TabListProvider
            tabList={chartAssetTypes}
            storage={{
              name: 'revenueChartTab',
              type: 'session',
            }}
          >
            <RevenueChartContainer />
          </TabListProvider>
        </ButtonGroupProvider>
      </Flex>
      {/* Asset Section */}
      <Flex isExpanded>
        <ButtonGroupProvider
          buttonGroup={rankingAssetType}
          storage={{
            name: 'revenueRankingButtonGroup',
            type: 'session',
          }}
        >
          <TabListProvider
            tabList={rankingAssetOwner}
            storage={{
              name: 'revenueRankingTab',
              type: 'session',
            }}
          >
            <MonthlyRevenueRankingContainer />
          </TabListProvider>
        </ButtonGroupProvider>
      </Flex>
    </Flex>
  );
}

export default withErrorBoundary(DashBoardPage);
